import {useGlobalState} from '../../util/GlobalState';
import styled from 'styled-components';
import {white, secondaryPinkLight, primaryPink, lemonMilk} from '../../Theme';
import {device} from '../../constants/breakpoints';
import forwardIcon from '../../resources/images/forwardWhite.svg';
import React from 'react';
import {useHistory} from 'react-router-dom';

function FooterContent(props) {
    const history = useHistory();

    return (
        <QuestionnaireButton onClick={() => history.push(`/ef-voortgang/${props.match.params.id}/vragenlijst`, {periodId: props.match.params.id})}>
            <QuestionnaireButtonText>Bekijk ingevulde vragenlijst</QuestionnaireButtonText>
            <QuestionnaireButtonIcon src={forwardIcon} alt={"Pijltje naar rechts"}/>
        </QuestionnaireButton>
    );
}

export function PlanOfActionDesktopFooter(props) {
    const [isNative] = useGlobalState('isNative', false)
    // Button to questionnaire should always be visible
    // let matchMentorPlanofActionScreen = useRouteMatch("/mentor/ef-voortgang/:pupilId");
    // if (matchMentorPlanofActionScreen) return null;

    return (
        <DesktopContentCardFooter isNative={isNative}>
            <FooterContent {...props} />
        </DesktopContentCardFooter>
    );
}

export function PlanOfActionTabletFooter(props) {
    const [isNative] = useGlobalState('isNative', false)
    // Button to questionnaire should always be visible
    // let matchMentorPlanofActionScreen = useRouteMatch("/mentor/ef-voortgang/:pupilId");
    // if (matchMentorPlanofActionScreen) return null;

    return (
        <TabletContentCardFooter isNative={isNative}>
            <FooterContent {...props} />
        </TabletContentCardFooter>
    );
}

const DesktopContentCardFooter = styled.div`
    width: 100%;
    height: 72px;
    background: ${secondaryPinkLight};
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: auto;

    @media screen and ${device.tablet} {
        display: none;
    }
`;

const TabletContentCardFooter = styled.div`
    display: none;

    @media screen and ${device.tablet} {
        width: 100%;
        height: 60px;
        background: ${secondaryPinkLight};
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 auto;
    }
`;

const QuestionnaireButton = styled.div`
    max-width: 318px;
    width: 100%;
    padding: 14px 20px;
    background: ${primaryPink};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    cursor: pointer;
`;

const QuestionnaireButtonText = styled.div`
    font-family: ${lemonMilk};
    font-size: 15px;
    color: ${white};
`;

const QuestionnaireButtonIcon = styled.img`
    width: 17px;
`;
